import { Injectable, EventEmitter } from "@angular/core";
import { environment } from "../../../../environments/environment";

// Enums
import { MessageTypeEnum } from "../../enums";

// Interfaces
import { IService, IMessage, IError } from "../../interfaces";

@Injectable()
export class PromptService implements IService {
	// implements local variables
	public showPrompt$ = new EventEmitter<IError>(true);
	public hidePrompt$ = new EventEmitter();

	// implements IService
	name = "PromptService";
	test(name, value) {
		console.log("testing", name, value);
	}

	constructor() {}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/services/prompt/prompt.service.ts